<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>服务管理</el-breadcrumb-item>
      <el-breadcrumb-item>待领取</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="left"
          label-width="80px"
        >
          <el-form-item label="客户" prop="customer_id">
            <customer-select
              :val="filter.customer_id"
              @change="filter.customer_id = $event"
            ></customer-select>
          </el-form-item>
          <el-form-item label="NCR编号" prop="number">
            <el-input
              size="small"
              v-model="filter.number"
              @keyup.enter.native="requestServiceQuest"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="ServiceOrder" prop="service_order_number">
            <el-input
              size="small"
              v-model="filter.service_order_number"
              @keyup.enter.native="requestServiceQuest"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="mt-10">
          <el-button type="primary" size="small" @click="requestServiceQuest()"
            >查询</el-button
          >
          <el-button size="small" @click="reset()">重置</el-button>
        </div>
      </div>
    </div>

    <div class="panel mt-20">
      <el-table
        size="mini"
        :data="serviceQuests"
        v-loading="loading"
        v-if="!isMobile()"
      >
        <el-table-column label="NCR / SO">
          <template slot-scope="scope">
            <service-quest-link
              :id="scope.row.id"
              :number="scope.row.number"
            ></service-quest-link>
            <div class="text-gray">{{ scope.row.service_order_number }}</div>
          </template>
        </el-table-column>
        <el-table-column label="客户 " min-width="200">
          <template slot-scope="scope"
            >{{ scope.row.customer.name
            }}<el-tag
              size="mini"
              type="danger"
              class="ml-5"
              v-if="
                scope.row.category == 1 && scope.row.customer.important == 2
              "
              >紧急</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column label="设备 / 设备描述 / 问题分类" min-width="220">
          <template slot-scope="scope">
            <div>
              {{ scope.row.device.serial_number
              }}<span v-if="scope.row.device.equipment_number"
                >（{{ scope.row.device.equipment_number }}）</span
              >
            </div>
            <div v-if="scope.row.device.description">
              {{ scope.row.device.description }}
            </div>
            {{
              scope.row.sub_category
                ? `${scope.row.cmm_category}（${scope.row.sub_category}）`
                : scope.row.cmm_category
            }}</template
          >
        </el-table-column>
        <el-table-column label="请求日期" align="center" width="150px">
          <template slot-scope="scope">
            <span>
              {{ formatTime(scope.row.created_at, 'YYYY-MM-DD HH:mm') }}
            </span>
          </template></el-table-column
        >
        <el-table-column label="当前步骤" align="center" width="120px">
          <template slot-scope="scope">
            <span class="status-tag-border info">
              {{
                scope.row.is_new_flow
                  ? scope.row.current_step.name
                  : ServiceQuestModeStatus[scope.row.mode_status]
              }}
            </span>
          </template></el-table-column
        >
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-popconfirm
              title="确认领取该工单吗？"
              @confirm="handleGrabServiceQuest(scope.row.id, scope.$index)"
            >
              <el-button slot="reference" size="mini" type="primary" plain
                >领取工单</el-button
              >
            </el-popconfirm>
            <router-link
              :to="$route.path + '/' + scope.row.id + '?origin=0'"
              v-permission="Auth.serviceQuestDetail"
              class="ml-5"
            >
              <el-button type="primary" size="mini" plain>查看</el-button>
            </router-link>
          </template></el-table-column
        >
      </el-table>
      <div v-else>
        <ul class="list-style">
          <li
            v-for="(item, index) in serviceQuests"
            :key="item.id"
            style="align-items: start"
            @click="$router.push(`${$route.path}/${item.id}?origin=0`)"
          >
            <div>
              <div
                class="flex-row-between"
                style="height: 20px; line-height: 20px; margin-bottom: 10px"
              >
                <div
                  class="flex-row"
                  style="line-height: 1.5; align-items: center"
                >
                  <span> NCR：{{ item.number || '-' }} </span>
                </div>
                <el-popconfirm
                  title="确认领取该工单吗？"
                  @confirm="handleGrabServiceQuest(item.id, index)"
                >
                  <el-button
                    class="mt-5"
                    slot="reference"
                    size="mini"
                    type="primary"
                    plain
                    @click.native.stop
                    >领取工单</el-button
                  >
                </el-popconfirm>
              </div>
              <div class="font-12">
                <span>Service Order：</span>
                {{ item.service_order_number }}
              </div>
              <div class="font-12">
                <span>客户：</span>
                <span>{{ item.customer.name }}</span>
              </div>
              <div class="font-12">
                <span>设备：</span>
                <span>
                  {{ item.device.item_category.whole_name.replace(/,/g, '-')
                  }}<span v-if="item.device.machine_type"
                    >（{{ item.device.machine_type }}）</span
                  >
                </span>
              </div>
              <div class="font-12">
                <span>问题分类：</span>
                <span>
                  {{
                    item.sub_category
                      ? `${item.sub_category}（${item.cmm_category}）`
                      : item.cmm_category
                  }}
                </span>
              </div>
              <div class="font-12">
                <span>请求日期：</span>
                <span>
                  {{ formatTime(item.created_at, 'YYYY-MM-DD HH:mm') }}
                </span>
              </div>
              <div class="font-12">
                <span>当前步骤：</span>
                <span class="text-info">
                  <span>
                    {{ ServiceQuestModeStatus[item.mode_status] }}
                  </span>
                </span>
              </div>
            </div>
          </li>
        </ul>
        <div
          class="font-12 text-gray text-center"
          v-if="serviceQuests.length == 0"
        >
          暂无待领取工单。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { serviceQuestList, serviceQuestGrab } from '../../service/getData'
import CustomerSelect from '@/components/select/customer_select'
import { formatTime, isMobile } from '@/util/index'
import { ServiceQuestModeStatus } from '@/config/global'

export default {
  components: {
    CustomerSelect,
  },
  data() {
    return {
      formatTime,
      isMobile,
      ServiceQuestModeStatus,
      serviceQuests: [],
      filter: {
        customer_id: null,
        number: null,
        service_order_number: null,
        // machine_type: null,
        // serial_number: null,
        // statuses: [2, 100],
        // date: '',
        page: 1,
        size: 500,
        category: 1,
        grab: true,
      },
    }
  },
  created() {
    this.requestServiceQuest()
  },
  methods: {
    async requestServiceQuest() {
      this.loading = true
      let query = Object.assign({}, this.filter)
      query.page = query.page - 1

      if (query.date && query.date.length == 2) {
        query.start_date = query.date[0] || ''
        query.end_date = query.date[1] || ''
      }

      let res = await serviceQuestList(query)
      if (res.code == 0) {
        this.serviceQuests = res.data.list || []
      }
      this.loading = false
    },
    reset() {
      this.$refs.filterForm.resetFields()
      this.requestServiceQuest()
    },

    async handleGrabServiceQuest(itemid, index) {
      let res = await serviceQuestGrab({ id: itemid })
      if (res.code == 0) {
        this.$message({
          message: '领取成功',
          type: 'success',
        })
        this.serviceQuests.splice(index, 1)
      }
    },
  },
}
</script>